import React from "react";
import { Card, KV, usd } from "./primitives";

/** Budget: registro dello strumento di collaudo (BUDGET_LEDGER) + politica budget viva del tenant (DB, gate server). */
export const BudgetCard = ({ b }) => {
  const led = b?.ledger || {}, t = led.totals || {}, p = b?.live_policy;
  const entries = (b?.ledger_entries || []).filter((e) => e.state === "FINISHED");
  return (
    <Card title="Budget del collaudo (plafond 25 USD, riserva 7 USD per i 3 PDF nuovi)" subtitle="Costi confermati dal provider per run; stima e consuntivo restano distinti; il gate è applicato anche lato server dalla politica budget del tenant." testId="cl-budget">
      <div className="grid gap-2 md:grid-cols-2">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground mb-1">Registro dello strumento di collaudo</div>
          <KV k="Plafond totale" v={usd(led.budget_total_usd, 2)} />
          <KV k="Confermato (Σ run terminati)" v={usd(t.confirmed_usd)} testId="cl-ledger-confirmed" />
          <KV k="Esposizione incerta" v={usd(t.uncertain_usd)} />
          <KV k="Tetti in corso" v={usd(t.inflight_caps_usd, 2)} />
          <KV k="Riserva 3 PDF nuovi" v={usd(t.reserve_new_pdfs_usd, 2)} />
          <KV k="Residuo totale (plafond − confermato − incerto)" v={usd(Number(led.budget_total_usd || 0) - Number(t.confirmed_usd || 0) - Number(t.uncertain_usd || 0))} testId="cl-ledger-residual-total" />
          <KV k="Disponibile per il prossimo tetto (oltre la riserva)" v={usd(t.available_for_next_cap_usd)} testId="cl-ledger-available" />
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground mb-1">Politica budget del tenant (server, dati in DB)</div>
          {p ? (
            <>
              <KV k="Plafond / riserva" v={`${usd(p.plafond_total_usd, 2)} / ${usd(p.reserved_usd, 2)}`} />
              <KV k={`Confermato dai run persistiti (${p.runs_counted})`} v={usd(p.confirmed_usd)} testId="cl-policy-confirmed" />
              <KV k="Incerto / tetti in corso" v={`${usd(p.uncertain_usd)} / ${usd(p.inflight_caps_usd, 2)}`} />
              <KV k="Disponibile per il prossimo tetto" v={usd(p.available_for_next_cap_usd)} testId="cl-policy-available" />
              <KV k="Tetto per documento" v={`minimo richiesto dal preflight${Number(p.per_document_cap_max_over_minimum_pct) ? ` +${p.per_document_cap_max_over_minimum_pct}%` : ""} (= worst case + margine)`} />
              <div className="text-[10px] text-muted-foreground mt-1">{p.gate_rule}</div>
            </>
          ) : <div className="text-risk-800" data-testid="cl-policy-absent">Nessuna politica budget registrata per il tenant.</div>}
        </div>
      </div>
      <details className="border border-border rounded-sm">
        <summary className="px-2 py-1 cursor-pointer text-[10px] font-bold bg-muted">Voci del registro ({entries.length})</summary>
        <div className="table-scroll">
          <table className="w-full text-[10px]" data-testid="cl-ledger-table">
            <thead><tr className="bg-muted text-left">{["Caso", "Run", "Tetto", "Confermato", "Incerto", "Stato run", "Registrato"].map((h) => <th key={h} className="px-2 py-1">{h}</th>)}</tr></thead>
            <tbody>{entries.map((e, i) => (
              <tr key={i} className="border-t border-border/60"><td className="px-2 py-1 font-bold">{e.case_id}</td><td className="px-2 py-1 font-mono">{(e.run_id || "").slice(0, 18)}…</td><td className="px-2 py-1">{usd(e.cap_usd, 2)}</td><td className="px-2 py-1">{usd(e.confirmed_usd)}</td><td className="px-2 py-1">{usd(e.uncertain_usd)}</td><td className="px-2 py-1">{e.run_status}</td><td className="px-2 py-1 font-mono">{String(e.at || "").slice(0, 19)}</td></tr>
            ))}</tbody>
          </table>
        </div>
      </details>
    </Card>
  );
};
